import env, { setEnv } from "../utils/env";
import { prepareHttpHeaders } from "../utils/http";

/*
* Endpoint for fetching authentication Token from Chronic Care API
* Example (as used in telemedicine member app):
await chronicCareTokenLogout(
  {
    baseUrl:            window.MOBILE_HOST, // mobile-api host
    apiToken:           window.MEMBER_APP_API_TOKEN, // API Token 
    authToken:          authToken.get().replace('Bearer ', ''), // JWT Token
    bundleIdentifier:   'com.td-core', // bundle identifier
    authorizedMemberId: memberId // Telemedicine member ID
  }
)
* Returns body as JSON
*/

const chronicCareTokenLogout = async ({
  baseUrl,
  apiToken,
  authToken,
  bundleIdentifier,
  authorizedMemberId
}) => {
  setEnv({
    BASE_URL: baseUrl,
    API_TOKEN: apiToken,
    AUTH_TOKEN: authToken,
    BUNDLE_ID: bundleIdentifier,
    locale: "en" // doesn't matter since we're not returning any renderables
  });

  return fetch(`${env("BASE_URL")}/utils/chronic_care/logout`, {
    method: "POST",
    headers: new Headers(prepareHttpHeaders()),
    body: JSON.stringify({ logged_in_member_id: Number(authorizedMemberId) })
  }).then(response => {
    if (!response.ok && response.status !== 400) {
      throw new Error(
        response.status === 401
          ? "Authentication error, please try logging out and then try again."
          : "An unknown server error occurred."
      );
    }
    return response.json();
  });
};

export default chronicCareTokenLogout;
